module.exports = __webpack_public_path__ + "static/media/icon_mensagem_recebida.6c51a402.svg";